export interface SolvaceRumClient {
  addAction: (name: string, context?: object) => void;
}

let rumClient: SolvaceRumClient | null = null;
let rumVersion: string | null = null;

export function setRumClient(client: SolvaceRumClient | null): void {
  rumClient = client;
}

export function getRumClient(): SolvaceRumClient | null {
  return rumClient;
}

export function setRumVersion(version: string | null | undefined): void {
  rumVersion = version || null;
}

export function getRumVersion(): string | null {
  return rumVersion;
}
